

export default {
    name:"icon",
    type:"string|(color:string,weight=2):string",
    description:"Action icon as url, base64 string or function",
}
